import fetchMerchandiseById from 'actions/merchandise/fetchMerchandiseById'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

type ReturnType = [
  App.MerchandiseOffer | undefined,
  boolean,
  { status: number, message: string } | any | undefined,
]

interface Options {
  disabled?: boolean;
}

function useMerchandiseOffer(id: string, options: Options = {}): ReturnType {
  const dispatch = useAppDispatch()
  const merchandise = useAppSelector(state => state.merchandise.merchandise[id])
  const fetching = useAppSelector(state => state.merchandise.fetchingMerchandise[id])
  const error = useAppSelector(state => state.merchandise.merchandiseErrors[id])

  useEffect(() => {
    if (!options.disabled) {
      dispatch(fetchMerchandiseById(id))
    }
  }, [dispatch, id, options.disabled])

  return [merchandise, !!fetching, error]
}

export default useMerchandiseOffer
